<template>
  <div class="cardContainer">
      <!--TEXT CARD-->
      <div v-if="answer.type === 'text'">
          <TextCard @returnClickedText="cardEvent($event)" v-bind:answer="answer"></TextCard>
      </div>
      <!--HERO CARD-->
      <div v-else-if="answer.type === 'hero'">
          <HeroCard @returnClickedHero="cardEvent($event)" v-bind:answer="answer"></HeroCard>
      </div>
      <!--THUMBNAIL CARD-->
      <div v-else-if="answer.type === 'thumbnail'">
           <ThumbnailCard @returnClickedThumbnail="cardEvent($event)" v-bind:answer="answer"></ThumbnailCard>
      </div>
      <!--VIDEO CARD-->
      <div v-else-if="answer.type === 'video'">
        <VideoCard @returnClickedVideo="cardEvent($event)" v-bind:answer="answer"></VideoCard>
      </div>
  </div>
</template>
<script>
import Vue from "vue";
import TextCard from './cards/TextCard.vue';
import HeroCard from './cards/HeroCard.vue';
import ThumbnailCard from './cards/ThumbnailCard.vue';
import VideoCard from './cards/VideoCard.vue';

export default {
  name: "CardContainer",
  props: ["answer"],
  components: {
      TextCard,
      HeroCard,
      ThumbnailCard,
      VideoCard
  },
  methods: {
    cardEvent(event) {
      console.log(event);
      this.$emit('collapseCard', event);
    }
  }
};
</script>
<style scoped>
.cardContainer {
  background-color: #3a3c3e;
  border-radius: 10px;
  padding: 5px 10px 5px 10px;
  margin-bottom: 5px;
}
</style>
